export const getCellText = (col, event) => {
  const v = event[col.id];
  return v == null || v === '' ? '' : String(v);
};

const neutralizeFormula = (s) => /^[=+\-@]/.test(s) ? `'${s}` : s;

export const buildRowTsv = (columns, event) =>
  columns.map(col => neutralizeFormula(getCellText(col, event).replace(/[\t\n\r]/g, ' '))).join('\t');
